// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.page-title[data-v-c8b5c4da] {\n  text-align: center;\n  /*background-color: #ebebeb;*/\n  /*width: 300px;*/\n  /*height: 450px;*/\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 200px;\n}\n.title-page p[data-v-c8b5c4da] {\n}\n\n", ""]);
// Exports
module.exports = exports;
